import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'atsCandidate';
const initialState = {
  notes: { data: [], meta: {} },
};

const { reducer, actions: atsCandidateActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    addContactNotes: (state, { payload }) => {
      const { meta = null, isInitial = false } = payload;
      const notes = Array.isArray(payload.notes) ? payload.notes : [];
      if (isInitial) {
        state.notes.data = [...notes].reverse();
        state.notes.meta = meta;
      } else {
        state.notes.data = [...[...notes].reverse(), ...state?.notes?.data];
        state.notes.meta = meta;
      }
    },

    addContactNote: (state, { payload }) => {
      const { newNote } = payload;
      state.notes.data =
        state?.notes?.data?.length > 0
          ? [...state?.notes?.data, newNote]
          : [newNote];
      state.notes.meta = {
        ...state.notes.meta,
        count: (state?.notes?.meta?.count || 0) + 1,
      };
    },

    updateContactNote: (state, { payload }) => {
      const { note, newNote } = payload;
      state.notes.data = state?.notes?.data?.map?.((item) => {
        if (item?.id === note?.id) return newNote;
        else return item;
      });
    },
  },
});

export { atsCandidateActions };
export default reducer;
